var _path, _circle, _circle2, _ellipse, _polygon, _polygon2, _path2, _circle3, _circle4, _circle5, _circle6, _polygon3, _circle7, _circle8, _circle9, _circle0, _polygon4, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _path3, _path4, _path5, _path6, _path7, _rect, _path8, _path9, _path0, _circle20, _circle21, _rect2, _rect3, _circle22, _path1, _path10;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServerError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 414 360",
    width: 414,
    height: 360,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#033B80",
    d: "M136.73,29.735 C103.355,60.5 39.605,11.735 31.355,65 C23.105,118.265 86.855,151.625 62.855,185.63 C38.855,219.635 12.605,298.13 67.355,332.87 C89.15,346.7 211.94,348.62 257.135,339.38 C302.33,330.14 480.995,275.975 386.135,157.88 C345.71,107.6 403.85,26.72 329.135,26.72 C271.1,26.735 206.87,-34.765 136.73,29.735 Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#033B80",
    d: "M51.5,112.64 C86.15,92.42 45.5,45.845 76.49,52.64 C136.685,65.735 116.81,-35.86 175.85,52.64 C212.9,108.14 283.325,37.895 319.37,53.45 C355.415,69.005 359.21,94.415 344.21,122.27 C329.21,150.125 312.74,176 328.295,196.61 C343.85,217.22 383.435,242.09 332.795,265.46 C282.155,288.83 278.465,382.715 208.37,354.05 C138.275,325.385 197.765,269.015 71.345,277.55 C16.82,281.285 -46.75,170 51.5,112.64 Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#033B80",
    d: "M351.695,288.95 L351.695,288.815 C351.604872,284.893783 348.356358,281.786216 344.435,281.87 C342.602765,281.861819 340.833,282.535506 339.47,283.76 C338.06962,280.757435 335.0429,278.851071 331.73,278.885 C329.564553,278.877484 327.475788,279.686211 325.88,281.15 C324.148505,277.376681 320.3563,274.977891 316.205,275.03 C310.535468,274.904304 305.836066,279.39559 305.705,285.065 C305.707507,286.40321 305.988462,287.726256 306.53,288.95 L351.695,288.95 Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 144.89,
    cy: 78.215,
    r: 27.615,
    fill: "#FFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 288.5,
    cy: 59.375,
    r: 9.585,
    fill: "#304FFE"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 288.491,
    cy: 59.367,
    fill: "#304FFE",
    rx: 3.165,
    ry: 15.495,
    transform: "rotate(-68.21 288.49 59.367)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "226.715 34.01 228.59 39.275 233.63 36.875 231.23 41.93 236.51 43.805 231.23 45.68 233.63 50.735 228.59 48.32 226.715 53.6 224.84 48.32 219.785 50.735 222.185 45.68 216.905 43.805 222.185 41.93 219.785 36.875 224.84 39.275"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "76.01 127.58 76.805 129.83 78.965 128.81 77.945 130.955 80.18 131.75 77.945 132.56 78.965 134.705 76.805 133.685 76.01 135.935 75.215 133.685 73.07 134.705 74.09 132.56 71.84 131.75 74.09 130.955 73.07 128.81 75.215 129.83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M400.495,233 C401.63555,231.56661 401.854511,229.606697 401.058409,227.956945 C400.262308,226.307193 398.591791,225.259063 396.76,225.26 L396.58,225.26 C395.951233,222.769051 393.679094,221.047246 391.110922,221.115587 C388.542751,221.183928 386.365399,223.024136 385.87,225.545 C385.09428,225.052519 384.193843,224.792277 383.275,224.795 C381.32841,224.785169 379.562561,225.934309 378.783177,227.718088 C378.003793,229.501868 378.360288,231.57832 379.69,233 L400.495,233 Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 254.54,
    cy: 94.46,
    r: 2.34,
    fill: "#FFF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 332.57,
    cy: 51.5,
    r: 1.875,
    fill: "#FFF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 336.92,
    cy: 88.055,
    r: 1.425,
    fill: "#FFF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 327.5,
    cy: 83.78,
    r: 2.85,
    fill: "#FFF"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "357.74 138.185 359.075 141.95 362.69 140.24 360.98 143.84 364.745 145.19 360.98 146.525 362.69 150.14 359.075 148.415 357.74 152.18 356.405 148.415 352.79 150.14 354.5 146.525 350.735 145.19 354.5 143.84 352.79 140.24 356.405 141.95"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.09,
    cy: 178.01,
    r: 2.34,
    fill: "#FFF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.89,
    cy: 168.05,
    r: 1.875,
    fill: "#FFF"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.66,
    cy: 139.13,
    r: 1.425,
    fill: "#FFF"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.015,
    cy: 187.015,
    r: 8.015,
    fill: "#304FFE"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "110.225 206.585 111.935 202.97 108.17 201.635 111.935 200.285 110.225 196.67 113.84 198.395 115.175 194.63 116.51 198.395 120.125 196.67 118.415 200.285 122.18 201.635 118.415 202.97 120.125 206.585 116.51 204.86 115.175 208.625 113.84 204.86"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.415,
    cy: 14.315,
    r: 1.71,
    fill: "#FFF"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.54,
    cy: 75.98,
    r: 6.3,
    fill: "#FFF"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 324.35,
    cy: 194.6,
    r: 6.3,
    fill: "#FFF"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.405,
    cy: 60.815,
    r: 2.22,
    fill: "#FFF"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 208.01,
    cy: 121.985,
    r: 1.14,
    fill: "#FFF"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.88,
    cy: 172.805,
    r: 2.88,
    fill: "#FFF"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.58,
    cy: 227.15,
    r: 3.045,
    fill: "#FFF"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 320.435,
    cy: 214.04,
    r: 1.44,
    fill: "#FFF"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 293.885,
    cy: 192.53,
    r: 2.07,
    fill: "#FFF"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 209.84,
    cy: 297.8,
    r: 1.83,
    fill: "#FFF"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 225.08,
    cy: 89.405,
    r: 1.35,
    fill: "#FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA71",
    d: "M305.00868 106.39368C306.180253 105.222107 308.079747 105.222107 309.25132 106.39368 310.422893 107.565253 310.422893 109.464747 309.25132 110.63632L124.87132 295.01632C123.699747 296.187893 121.800253 296.187893 120.62868 295.01632 119.457107 293.844747 119.457107 291.945253 120.62868 290.77368L305.00868 106.39368zM156.5 91.625L203.57 138.695 153.05 189.215 105.98 142.145C100.883873 137.038998 100.883873 128.771002 105.98 123.665L138.05 91.625C143.152529 86.548802 151.397471 86.548802 156.5 91.625z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8BB40",
    d: "M158.615826,89.4981992 L205.69132,136.57368 C206.862893,137.745253 206.862893,139.644747 205.69132,140.81632 L155.17132,191.33632 C153.999747,192.507893 152.100253,192.507893 150.92868,191.33632 L103.856627,144.264266 C97.5916639,137.987163 97.5916639,127.822837 103.859673,121.542687 L135.934174,89.4981992 C142.207008,83.2577356 152.342992,83.2577356 158.615826,89.4981992 Z M140.170327,93.7473128 L108.103373,125.784266 C104.176082,129.719167 104.176082,136.090833 108.10132,140.02368 L153.05,184.972359 L199.327359,138.695 L154.381599,93.7492393 C150.449176,89.8398686 144.097192,89.8407215 140.170327,93.7473128 Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA71",
    d: "M324.02,259.115 L276.95,212 L226.43,262.52 L273.5,309.635 C278.606002,314.731127 286.873998,314.731127 291.98,309.635 L324.02,277.595 C329.116127,272.488998 329.116127,264.221002 324.02,259.115 Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8BB40",
    d: "M326.142334,256.994693 C332.408336,263.272837 332.408336,273.437163 326.14132,279.71632 L294.099266,311.758373 C287.822163,318.023336 277.657837,318.023336 271.377666,311.755307 L224.307666,264.640307 C223.137049,263.46857 223.137503,261.569857 224.30868,260.39868 L274.82868,209.87868 C276.000648,208.706711 277.900925,208.707165 279.072334,209.879693 L326.142334,256.994693 Z M276.948986,216.243654 L230.671627,262.521013 L275.619266,307.511627 C279.554167,311.438918 285.925833,311.438918 289.85868,307.51368 L321.896627,275.475734 C325.823756,271.540996 325.823918,265.169693 321.897114,261.234753 L276.948986,216.243654 Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8BB40",
    d: "M310.84132,290.77368 C312.012893,291.945253 312.012893,293.844747 310.84132,295.01632 C309.669747,296.187893 307.770253,296.187893 306.59868,295.01632 L120.62868,109.04632 C119.457107,107.874747 119.457107,105.975253 120.62868,104.80368 C121.800253,103.632107 123.699747,103.632107 124.87132,104.80368 L310.84132,290.77368 Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52.56,
    height: 19.935,
    x: 232.882,
    y: 146.51,
    fill: "#F8BB40",
    rx: 5.985,
    transform: "rotate(45 259.162 156.478)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8BB40",
    d: "M304.565,111.08 C302.665947,109.179331 300.089309,108.111411 297.4025,108.111411 C294.715691,108.111411 292.139053,109.179331 290.24,111.08 L304.565,125.405 C308.50661,121.443418 308.50661,115.041582 304.565,111.08 Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA71",
    d: "M270.5 145.19C285.383946 160.069668 309.511054 160.069668 324.395 145.19L270.5 91.295C255.620332 106.178946 255.620332 130.306054 270.5 145.19zM190.805 280.43C191.33 279.965 191.855 279.47 192.305 278.93L274.235 197C277.624181 193.622566 279.529194 189.034727 279.529194 184.25 279.529194 179.465273 277.624181 174.877434 274.235 171.5L244.055 141.32C240.677566 137.930819 236.089727 136.025806 231.305 136.025806 226.520273 136.025806 221.932434 137.930819 218.555 141.32L135.05 224.825C133.495856 226.386392 132.244707 228.222427 131.36 230.24 121.392561 246.192552 124.142443 266.973538 137.916068 279.78451 151.689693 292.595481 172.615144 293.835134 187.805 282.74 188.847674 282.067654 189.81345 281.282961 190.685 280.4L190.805 280.43z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF2456",
    d: "M221,161.975 L209.495,150.5 L173.705,186.29 L185.225,197.81 C186.960911,199.547624 189.31634,200.523955 191.7725,200.523955 C194.22866,200.523955 196.584089,199.547624 198.32,197.81 L221,175.07 C222.737624,173.334089 223.713955,170.97866 223.713955,168.5225 C223.713955,166.06634 222.737624,163.710911 221,161.975 Z"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 206.87,
    cy: 171.035,
    r: 4.8,
    fill: "#033B80"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.505,
    cy: 184.4,
    r: 4.8,
    fill: "#033B80"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20.25,
    height: 7.911,
    x: 258.49,
    y: 143.066,
    fill: "#F8BB40",
    rx: 3.675,
    transform: "rotate(45 268.615 147.021)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 20.25,
    height: 7.365,
    x: 124.51,
    y: 277.325,
    fill: "#F8BB40",
    rx: 3.675,
    transform: "rotate(45 134.635 281.008)"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.75,
    cy: 292.895,
    r: 10.125,
    fill: "#F8BB40"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8BB40",
    d: "M163.93368 99.0286797C165.105253 97.8571068 167.004747 97.8571068 168.17632 99.0286797 169.347893 100.200253 169.347893 102.099747 168.17632 103.27132L117.65632 153.79132C116.484747 154.962893 114.585253 154.962893 113.41368 153.79132 112.242107 152.619747 112.242107 150.720253 113.41368 149.54868L163.93368 99.0286797zM182.713995 117.808365C183.885741 116.636966 185.785236 116.637248 186.956635 117.808995 188.128034 118.980741 188.127752 120.880236 186.956005 122.051635L136.421005 172.571635C135.249259 173.743034 133.349764 173.742752 132.178365 172.571005 131.006966 171.399259 131.007248 169.499764 132.178995 168.328365L182.713995 117.808365zM293.59368 228.68868C294.765253 227.517107 296.664747 227.517107 297.83632 228.68868 299.007893 229.860253 299.007893 231.759747 297.83632 232.93132L247.31632 283.45132C246.144747 284.622893 244.245253 284.622893 243.07368 283.45132 241.902107 282.279747 241.902107 280.380253 243.07368 279.20868L293.59368 228.68868zM312.37368 247.45368C313.545253 246.282107 315.444747 246.282107 316.61632 247.45368 317.787893 248.625253 317.787893 250.524747 316.61632 251.69632L266.08132 302.23132C264.909747 303.402893 263.010253 303.402893 261.83868 302.23132 260.667107 301.059747 260.667107 299.160253 261.83868 297.98868L312.37368 247.45368zM261.71 159.005C261.71 159.005 276.2 177.425 266.48 177.875 252.32 178.535 270.125 200.375 237.875 210.035 206.375 219.44 190.625 273.95 179.75 280.34 168.875 286.73 162.26 267.935 159.575 273.95 156.89 279.965 157.7 282.62 149.75 282.8 141.8 282.98 138.995 280.955 138.995 280.955 147.106434 288.62423 158.348062 292.040041 169.355 290.18 178.085 288.68 185.57 285.68 192.35 278.975 197.375 273.965 270.815 201.785 274.235 197 277.655 192.215 283.985 182 274.235 171.5 264.485 161 261.71 159.005 261.71 159.005z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M72.11,258.245 C72.11,258.245 74.9,258.245 74.9,258.245 L134.45,258.245 C138.17,258.245 139.1,256.4 139.1,254.54 C139.116078,253.538201 138.69773,252.578484 137.952859,251.908388 C137.207989,251.238292 136.209525,250.923425 135.215,251.045 C134.970243,251.029554 134.724757,251.029554 134.48,251.045 C133.468875,248.124082 130.715975,246.16633 127.625,246.17 C127.054634,246.173892 126.486349,246.239269 125.93,246.365 C125.411082,241.699719 121.546409,238.122501 116.855,237.965 C115.063245,233.253715 110.569537,230.120008 105.52932,230.066988 C100.489103,230.013968 95.9304676,233.052449 94.04,237.725 C91.2457829,235.180169 87.345157,234.239134 83.6979551,235.229957 C80.0507532,236.220781 77.1624638,239.006138 76.04,242.615 C73.509466,241.830135 70.7566497,242.292025 68.6208681,243.859843 C66.4850864,245.42766 65.219508,247.915561 65.21,250.565 C65.255,254 67.46,258.245 72.11,258.245 Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerError);
export default __webpack_public_path__ + "static/media/server-error.1a905fc7e71d058631db00ca6a5fdcbf.svg";
export { ForwardRef as ReactComponent };